module.exports = __webpack_public_path__ + "img/ic_edit.9f596bd2.svg";